<input type="text" inputmode="decimal" class="form-control" [value]="displayValue" [readonly]="readonly" [disabled]="isDisabled" (input)="onInput($any($event.target))" (blur)="onBlur()">
